<template>
  <div class="loading-indicator">
    <span class="spinner" :style="getStyles" v-text="translate('lblLoading')"></span>
  </div>
</template>

<script>
export default {
  name: 'LoadingIndicator',
  props: {
    spinnerOffsetTop: {
      type: String,
    },
  },
  computed: {
    getStyles() {
      const styles = {};
      styles['--spinner-offset-top'] = this.spinnerOffsetTop ? this.spinnerOffsetTop : '50%';
      return styles;
    },
  },
};
</script>

<style scoped lang="scss">
.loading-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.4);
  color: #ffffff;
  z-index: 10001;

  &.in-container {
    position: absolute;
  }

  .spinner {
    display: block;
    text-indent: -6250rem;

    &:before {
      content: '';
      box-sizing: border-box;
      position: absolute;
      top: var(--spinner-offset-top);
      left: 50%;
      width: 40px;
      height: 40px;
      margin-top: -20px;
      margin-left: -20px;
      border-radius: 50%;
      border-top: 2px solid #ff6c00;
      border-right: 2px solid transparent;
      animation: loadingspinner 1.4s linear infinite;
    }
  }
}
</style>
